/* eslint-disable no-unused-vars */
// custom components
import { TypingContainer } from 'components';

//material ui components
import { Box, Typography, Button, Grid, Tooltip, makeStyles } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
// import Diff from './Diff';
import * as diff from 'diff';
window.diff = diff;
import PropTypes from 'prop-types';
import innerText from 'react-innertext';
import { useUserContext } from 'UserProvider';
import { useLocation, useNavigate } from 'react-router-dom';
// import DOMPurify from 'dompurify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import warningIcon from '../../assets/images/logos/Warning-Symbol_Warning-Message.svg';

//Plugins
import '../../utils/Plugin/horizontalBorder.js';
// import '../../utils/Plugin/verticalBorder.js';
import '../../utils/Plugin/headerAndFooter.js';
// import '../../utils/Plugin/bulletList.js';
import '../../utils/Plugin/symbols.js';
// import '../../utils/Plugin/spellchecker.js';
import '../../utils/Plugin/horizontalRuler.js';
import '../../utils/Plugin/customColumn.js';
import '../../utils/Plugin/footnotes.js';
import '../../utils/Plugin/customFolderPlugin.js';
import '../../utils/Plugin/sortingTable.js';

//constant

//images

// icons
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ReplayIcon from '@mui/icons-material/Replay';
// const { borderRadius } = borders;
// icons styling
import axios from '../../services/local/api';
import moodleAxios from '../../services/moodle/moodleApi';
import { baseURLs } from 'utils/baseURLs';
import './styles.css';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getExerciseByCourseIdAsync } from 'store/slices/exerciseSlice/exerciseSlice.js';
import { CircularProgress } from '@mui/material';

const useStyles = makeStyles(theme => ({
  outerDiv: {
    padding: '3px',
    boxShadow: ` 0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%)`,

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.grey[200],
      boxShadow: ` 0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%)`
    }
  },
  button: {
    outline: '0 !important',
    borderRadius: 8,
    backgroundColor: 'white',
    margin: '15px 36px',
    minWidth: '150px',
    fontSize: '18px',
    boxShadow: `0.3rem 0.3rem 0.5rem #c3c1c6, -0.2rem -0.2rem 0.4rem #fff;`,
    color: '#668fff',
    textShadow: `1px 1px 0 #fff`,
    transition: `all 0.3s ease-in-out`,
    '&:hover': {
      backgroundColor: `#668fff`,
      color: '#ffffff',
      textShadow: `1px 1px 0 #668fff`
    }
  },
  buttonClick: {
    outline: '0 !important',
    minWidth: '150px',
    borderRadius: 8,
    margin: '15px 36px',
    boxShadow: `inset 0.2rem 0.2rem 0.5rem rgb(195 193 198 / 90%), inset -0.2rem -0.2rem 0.5rem #fff,
    0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem #fff;`,
    backgroundColor: `#fff`,
    color: '#ffffff',
    textShadow: `1px 1px 0 #668fff`,
    cursor: 'not-allowed',
    transition: `all 0.5s ease-in-out`
  },
  buttonOutline: {
    display: 'flex',
    flexDirection: 'row-reverse'
  },
  directions: {
    paddingRight: '10px'
  }
}));

const EditorPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [view, setView] = useState(false);
  // const [text, setText] = useState(false);
  const [check, setCheck] = useState(false);
  const [result, setResult] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [count, setCount] = useState(0);
  const [final, Setfinal] = useState();
  const [totalerror, SetTotalerror] = useState();
  const [percentage, setPercentage] = useState();
  const [html, setHtml] = useState();
  const [instance, setInstanceData] = useState();
  const [baseVal, setBaseVal] = useState();
  const [newVal, setNewVal] = useState();
  const [secondFlag, setSecondFlag] = useState(false);
  const location = useLocation();
  const routes = location.pathname.split('/');
  const urlId = routes[routes.length - 1].split('%20');
  const InstanceId = urlId[urlId.length - 1].split('-').pop();
  const [attemptsRemaining, setAttemptsRemaining] = useState(0);
  const { userContext } = useUserContext();
  const [resubmitCount, setResubmitCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const parser = new DOMParser();
  const [modelDocBase64, setModelDocBase64] = useState('');
  const [docBase64Content, setDocBase64Content] = useState('');
  const [callPostResultApi, setCallPostResultApi] = useState(false);
  const [dataForSendingToMoodle, setDataForSendingToMoodle] = useState();
  const [fixedPercentage, setFixedPercentage] = useState(0);
  const links = location.state;
  // SJK: CKey-101
  const [transId, setTransId] = useState();

  const replaced = val => {
    if (val === undefined) {
      return val;
    } else {
      val = val.toString()?.replace(/\//g, '');
      val = val.toString()?.replace(/\?/g, '');
      return val.toString()?.replace(/ /g, '_');
    }
  };
  // console.log(links);
  //let index = links.links.findIndex(x => x.id == InstanceId);
  // CKey-112: Fix on reload
  let index = -1;
  if (links?.links?.length) {
    index = links.links.findIndex(
      (x) => x.id == InstanceId
    );
  }
  // console.log(index);
  useEffect(() => {
    // console.log(location.state.courseID)
    if (!result && secondFlag === false) {
      setTimeout(() => setSeconds(seconds + 1), 1000);
    }
  }, [seconds, result, secondFlag]);
  const fetchGradedAttemptsRemaining = async activityID => {
    const userId = userContext?.userData?.id || localStorage.getItem('userid');
    const courseIDSelected =
      localStorage.getItem('courseIdselected') &&
      localStorage.getItem('courseIdselected') !== 'undefined'
        ? localStorage.getItem('courseIdselected')
        : sessionStorage.getItem('activityInstance');
    try {
      const url = `${process.env.REACT_APP_MOODLE_DEVELOPMENT_URL}/mod/kb/appservice_kbws.php?action=gradedattemptsremaining&userid=${userId}&activityid=${activityID}&id=${courseIDSelected}`;

      const response = await fetch(url);

      const data = await response.json();
      setAttemptsRemaining(data);
    } catch (error) {
      console.error('Error fetching graded attempts:', error);
    }
  };

  const generateWCPrefix = siteUrl => {
    const parsedUrl = new URL(siteUrl);
    return parsedUrl.hostname.replace(/\./g, '_'); // Replace dots with underscores
  };
  // SJK: CKey-101 : Comment code
  /*const generateTransId = (WC_PREFIX, attemptId, resubmitCount, timeStart) => {
    return `${WC_PREFIX}${attemptId}_${resubmitCount}_${timeStart}`;
  };*/
  const generateTransId = (WC_PREFIX, userid, courseid, activityid, resubmitCountDoc, timeStart) => {
    return `${WC_PREFIX}_${userid}_${courseid}_${activityid}_${resubmitCountDoc}_${timeStart}`;
  };
  const convertToBase64Docx = async htmlContent => {
    try {
      const response = await fetch('/html-docx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          html: htmlContent,
          uid: userContext?.userData?.id || localStorage.getItem('userid'),
          activityName: window.location.pathname.split("/").pop()
        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setModelDocBase64(data.base64Docx);
    } catch (error) {
      console.error('Error downloading the document:', error);
    }
  };

  useEffect(() => {
    // console.log('baseval changed to: ', html);
    if (html != undefined) {
      //JG: CKEY-61 html is getting set to base64 encoded string of model doc.
      setModelDocBase64(html);
      //convertToBase64Docx(html);
    }
  }, [html]);
  const generateFileName = (type, transId, refDpa) => {
    return `pp.${type}.${transId}.${refDpa}.docx`;
  };
  const generateFileNameModel = (type, refDpa) => {
    return `pp.${type}.${refDpa}.docx`;
  };
  const [docUrl, setDocUrl] = useState([]);
  const [docError, setDocError] = useState(0);
  const [wpm, setWpm] = useState(0);
  const [typingStarted, setTypingStarted] = useState(false);
  const [time, setTime] = useState(0);
  useEffect(() => {
    if (typingStarted) {
      setTimeout(() => setTime(time + 1), 1000);
    }
  }, [typingStarted, time]);
  const generateDocxUrl = async base64Docx => {
    try {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      const raw = JSON.stringify({
        accessToken: sessionStorage.getItem('aspose_access_token'),
        base64Docx: base64Docx
      });
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      const url = '/base64-pdf';
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      const docs = `/public/${data.fileName}`;
      setDocUrl(docs);
    } catch (error) {
      console.error('Error generating document URL:', error);
    } finally {
      setLoading(false);
    }
  };
  let currentAttemptId = 3750345;
  // SJK: CKey-101
    const attemptsAllowed = Number(
      instance?.Activities?.Activity?.attributes?.AttemptsAllowed ?? 0
    );

    const attemptsRemainingDoc = Number(
      attemptsRemaining?.attributes?.AttemptsRemaining ?? 0
    );
    let resubmitCountDoc = 0;
    resubmitCountDoc = Math.max(
      0, attemptsAllowed - attemptsRemainingDoc
    );
    const userid = userContext?.userData?.id || localStorage.getItem('userid');
    const courseid =
      localStorage.getItem('courseIdselected') &&
      localStorage.getItem('courseIdselected') !== 'undefined'
        ? localStorage.getItem('courseIdselected')
        : sessionStorage.getItem('activityInstance');
    const activityid =  location.pathname.split('-').pop();
  const handleGenerate = async (submittedDocBase64, exportMoodObj = null) => {
    const siteUrl = instance?.attributes?.LmsUrl;
    const attemptId = currentAttemptId++;
    const timeStart = instance?.attributes?.CurrentTime;
    const label = instance?.Activities?.Activity?.Label;
    const refDpa = label ? parseInt(label.replace(/[^0-9]/g, ''), 10) : 0;
    const wcPrefix = generateWCPrefix(siteUrl);
    //const transactionId = generateTransId(wcPrefix, attemptId, resubmitCount, timeStart);
    // SJK : CKey-101
    const transactionId = generateTransId(wcPrefix, userid, courseid, activityid, resubmitCountDoc, timeStart);
    setTransId(transactionId);
    const submittedName = generateFileName('submitted', transactionId, refDpa);
    const modelName = generateFileNameModel('model', refDpa);
    // Call CompareMe API
    const compareMeSuccess = await callSOAPApi(
      'CompareMe',
      transactionId,
      submittedDocBase64,
      submittedName,
      modelName
    );
    if (compareMeSuccess) {
      // Call CheckTransactionStatus API
      setTimeout(async () => {
        const transactionStatusSuccess = await callCheckTransactionStatusApi(transactionId);
        if (transactionStatusSuccess) {
          // Call GetResultsDoc API
          await callGetResultsDocApi(transactionId, exportMoodObj);
        }
      }, 3000);
    }
  };
  const callSOAPApi = async (
    action,
    transactionId,
    submittedDoc,
    submittedDocName,
    modelDocName
  ) => {
    setDocBase64Content(submittedDoc);
    const soapBody = `<SOAP-ENV:Envelope xmlns:SOAP-ENV="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ns1="http://tempuri.org/">\r\n    <SOAP-ENV:Body>\r\n        <ns1:${action}>\r\n            <ns1:transId>${transactionId}</ns1:transId>\r\n            <ns1:submittedDoc>${submittedDoc}</ns1:submittedDoc>\r\n            <ns1:submittedDocName>${submittedDocName}</ns1:submittedDocName>\r\n            <ns1:modelDoc>${modelDocBase64}</ns1:modelDoc>\r\n            <ns1:modelDocName>${modelDocName}</ns1:modelDocName>\r\n        </ns1:${action}>\r\n    </SOAP-ENV:Body>\r\n</SOAP-ENV:Envelope>`;
    try {
      const url = `${
        process.env.IS_LOCAL === 'true' ? process.env.REACT_APP_Backend_DEVELOPMENT_URL : ''
      }/compare-doc-with-moodle`;
      const response = await axios.post(url, { action, soapBody });
      // Check if the response indicates success
      return response.data.includes('<a:IsSuccess>true</a:IsSuccess>');
    } catch (error) {
      console.error(`Error calling ${action} API:`, error);
      return false;
    }
  };
  const callCheckTransactionStatusApi = async transactionId => {
    const soapBody = `<?xml version="1.0" encoding="UTF-8"?>\r\n<SOAP-ENV:Envelope xmlns:SOAP-ENV="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ns1="http://tempuri.org/">\r\n    <SOAP-ENV:Body>\r\n        <ns1:CheckTransactionStatus>\r\n            <ns1:transId>${transactionId}</ns1:transId>\r\n        </ns1:CheckTransactionStatus>\r\n    </SOAP-ENV:Body>\r\n</SOAP-ENV:Envelope>`;
    try {
      const url = `${
        process.env.IS_LOCAL === 'true' ? process.env.REACT_APP_Backend_DEVELOPMENT_URL : ''
      }/compare-doc-with-moodle`;
      let count = 0;
      let transactionComplete = false;
      let baseDelay = 2000; // 2 seconds initial wait
      const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      do {
        const response = await axios.post(url, {
          action: 'CheckTransactionStatus',
          soapBody
        });
        if (response.data.includes('<a:IsSuccess>true</a:IsSuccess>') && response.data.includes('<a:StatusCode>4</a:StatusCode>')) {
            transactionComplete = true;
          }
        if (!transactionComplete) {
          // exponential backoff: 2s, 4s, 8s, 16s...
          const currentDelay = baseDelay * Math.pow(2, count);
          console.log(`Compare Transaction still processing, Retrying in ${currentDelay / 1000} seconds...`);
          await delay(currentDelay);
        }
      } while (!transactionComplete && count++ < 6);

      return (transactionComplete);
    } catch (error) {
      console.error('Error calling CheckTransactionStatus API:', error);
      return false;
    }
  };
  const callGetResultsDocApi = async (transactionId, exportMoodObj = null) => {
    const soapBody = `<?xml version="1.0" encoding="UTF-8"?>\r\n<SOAP-ENV:Envelope xmlns:SOAP-ENV="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ns1="http://tempuri.org/">\r\n    <SOAP-ENV:Body>\r\n        <ns1:GetResultsDoc>\r\n            <ns1:transId>${transactionId}</ns1:transId>\r\n        </ns1:GetResultsDoc>\r\n    </SOAP-ENV:Body>\r\n</SOAP-ENV:Envelope>`;
    try {
      const url = `${
        process.env.IS_LOCAL === 'true' ? process.env.REACT_APP_Backend_DEVELOPMENT_URL : ''
      }/compare-doc-with-moodle`;
      const response = await axios.post(url, {
        action: 'GetResultsDoc',
        soapBody
      });
      const xmlDoc = parser.parseFromString(response.data, 'text/xml');
      const resultDocFile = xmlDoc.getElementsByTagName('a:ResultDocFile')[0]?.textContent;
      let fileName = xmlDoc.getElementsByTagName('a:ResultDocName')[0]?.textContent;
      let err = exportMoodObj.err ?? 0;
      if (typeof fileName === 'string') {
        err = fileName.split('.');
        err = err.length > 1 ? err[err.length - 2] : 0;
        setDocError(err);
        let percent = (err ?? 0) / (instance?.Activities.Activity.attributes.ErrorGoal ?? 1);
        percent = (1 - percent) * 100;
        if (percent < 0) percent = 0;
        percent = Math.round(percent * 100, 2) / 100;
        setFixedPercentage(percent);

        const parser = new DOMParser();
        const doc = parser.parseFromString(newVal, 'text/html');
        const text = doc.body.textContent || '';
        const words = text.trim().split(/\s+/);
        const wordCount = words.filter(word => word.length > 0).length;
        setWpm(Math.floor((wordCount * 60) / (time > 0 ? time : 1)));
      }
      // Process the result document (e.g., save or display it)
      // Example: set the result in state
      generateDocxUrl(resultDocFile);
      Export2Word(
        exportMoodObj.percent,
        err,
        exportMoodObj.string,
        exportMoodObj.string2,
        exportMoodObj.base64String,
        resultDocFile,
        fileName,
        transactionId // SJK: CKey-101
      );
      // percent: similarity(string1, str),
      // err: intcount + actualError,
      // string: string1,
      // string2: string2,
      // base64String:base64String
    } catch (error) {
      console.error('Error calling GetResultsDoc API:', error);
    }
  };
  const handleClick = async () => {
    setCheck(true);
  };
  useEffect(() => {
    const fetch = async () => {
      // SJK: CKey-85 : Append userid to Moodle API
      const res = await moodleAxios.get(baseURLs.Service_for_KB_data + InstanceId + "&userid=" + (
        localStorage.getItem("userid") || userContext?.userData?.id || ""
        ));
      fetchGradedAttemptsRemaining(res.data?.Activities?.Activity?.attributes?.Id);
      // console.log(res.data);
      setInstanceData(res.data);
    };
    fetch();
  }, [InstanceId]);
  //const lastID = links.links[links.links.length - 1]?.id;
  // CKey-112: Fix link on reload
  const lastID = links?.links?.[links?.links?.length - 1]?.id;

  const instanceID = location.pathname.split('-').pop();

  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  const prevPath = sessionStorage.getItem('pathnameForNext');
  const prevPathLastSegment = prevPath ? prevPath?.split('/').filter(Boolean).pop() : null;
  const exercises = useSelector(getExerciseByCourseIdAsync);

  const fetchExercises = async iditem => {
    if (!Array.isArray(exercises)) {
      console.error('Error: `exercises` is not an array', exercises);
      return;
    }

    //console.log('JG_debug001: ' + JSON.stringify(exercises));
    const currentExerciseIndex = exercises.findIndex(item => item?.id == Number(prevPathLastSegment));

    if (!currentExerciseIndex) {
      console.warn('No matching object found for prevPathLastSegment.');
      return;
    }
    
    const nextMatchingObject = exercises[currentExerciseIndex + 1];

    if (nextMatchingObject) {
      localStorage.setItem(
        'courseIdselected',
        iditem,
        nextMatchingObject?.id,
        nextMatchingObject?.name
      );

      const pathnameForNext = `/courses/courses/${nextMatchingObject?.id}`;

      navigate(pathnameForNext, {
        state: {
          modules: nextMatchingObject?.modules,
          session: nextMatchingObject?.name,
          courseID: iditem,
          links: `${nextMatchingObject?.id}-${iditem}`
        }
      });

      sessionStorage.setItem('pathnameForNext', pathnameForNext);
    } else {
      console.warn('No visible exercise found in the next section.');
      // Optional: Show a user-friendly message here
    }
  };

  /* Tying Test header */
  // console.log(links.links[index + 1].id);
  // console.log(index);
  // console.log(links.links[index + 1].name);
  // console.log(links.links.length);
  const [open, setOpen] = useState(false);
  const [openPrevious, setOpenPrevious] = useState(false);

  const handleNavigateAway = () => {
    // console.log('next');
    const nextVisibleLink = links?.links?.slice(index + 1).find(item => item.visible === 1);

    if (nextVisibleLink) {
      const path = nextVisibleLink.name?.split(' ').includes('Document')
        ? `/courses/editor/${replaced(nextVisibleLink.name)}-${replaced(nextVisibleLink.id)}`
        : `/courses/typing/${replaced(nextVisibleLink.name)}-${replaced(nextVisibleLink.id)}`;

      navigate(path, { state: links });
    } else {
      console.warn('No next visible exercise found');
      // Optionally show a message or prevent navigation
    }
  };

  const handleWarningOpen = useCallback(() => {
    if (!open) setOpen(true); // Open dialog only if not already open
  }, [open]);

  const handleWarningClose = useCallback(() => {
    setSecondFlag(false);
    setOpen(false); // Close dialog
  }, []);

  const handlePreviousWarningOpen = useCallback(() => {
    if (!openPrevious) setOpenPrevious(true); // Open dialog only if not already open
  }, [openPrevious]);

  const handlePreviousWarningClose = () => {
    setSecondFlag(false);
    setOpenPrevious(false);
  };

  const timeOpen = Number(instance?.Activities?.Activity?.attributes?.TimeOpen || 0);
  const timeClose = Number(instance?.Activities?.Activity?.attributes?.TimeClose || 0);
  const isAvalible = instance?.Activities?.Activity?.attributes?.Avalible;
  const restrictMessage = instance?.Activities?.Activity?.attributes?.RestrictReason;
  const attemptsRemainingvar = attemptsRemaining?.attributes?.AttemptsRemaining;

  const now = new Date();
  const openDate = timeOpen !== 0 ? new Date(timeOpen * 1000) : null;
  const closeDate = timeClose !== 0 ? new Date(timeClose * 1000) : null;

  let isRestricted = false;
  let accessMessage = '';

  // Restrict based on time
  if (openDate && closeDate) {
    if (now < openDate || now > closeDate) {
      isRestricted = true;
      accessMessage = `The current activity is only available after ${openDate.toLocaleString()} and before ${closeDate.toLocaleString()}.`;
    }
  } else if (openDate && now < openDate) {
    isRestricted = true;
    accessMessage = `The current activity is only available after ${openDate.toLocaleString()}.`;
  } else if (closeDate && now > closeDate) {
    isRestricted = true;
    accessMessage = `The current activity is only available before ${closeDate.toLocaleString()}.`;
  } else if (openDate == null && closeDate == null) { //if no user overrides and no open/close dates and restricted access is set
    if(isAvalible == "False") {
      isRestricted = true;
      accessMessage = restrictMessage;
    }
  } else {
    console.log("no avalibility restriction for the module");
  }

  // Restrict based on attempts
  if (attemptsRemainingvar === '0') {
    isRestricted = true;
    accessMessage = 'No attempts remaining for this activity.';
  }
  // Find the previous visible link before rendering
  const prevVisibleLink = [...(links?.links || [])]
    .slice(0, index)
    .reverse()
    .find(item => item.visible === 1);

  const prevPath1 = prevVisibleLink
    ? prevVisibleLink.name?.split(' ').includes('Document')
      ? `/courses/editor/${replaced(prevVisibleLink.name)}-${replaced(prevVisibleLink.id)}`
      : `/courses/typing/${replaced(prevVisibleLink.name)}-${replaced(prevVisibleLink.id)}`
    : null; // null if no previous visible link

  // Find the next visible link after the current index
  const nextVisibleLink = links?.links?.slice(index + 1).find(item => item.visible === 1);

  const nextPath = nextVisibleLink
    ? nextVisibleLink.name?.split(' ').includes('Document')
      ? `/courses/editor/${replaced(nextVisibleLink.name)}-${replaced(nextVisibleLink.id)}`
      : `/courses/typing/${replaced(nextVisibleLink.name)}-${replaced(nextVisibleLink.id)}`
    : null; // null if no next visible link
   // CKey-112
  const navenable = sessionStorage.getItem('navigation') === 'true';
  const HeaderComp = () => (
    <Box>
      <Grid container rowspacing={{ xs: 1, md: 0 }} columnspacing={{ lg: 5 }} columns={12}>
        {instance &&
          instance.Activities.Activity.Instructions &&
          instance.Activities.Activity.Instructions !== '' &&
          Object.keys(instance.Activities.Activity.Instructions).length > 0 && (
            <Grid container item xs={12} lg={10}>
              <Grid align="left" className={classes.directions} item xs={'auto'}>
                <Typography>Directions: </Typography>
              </Grid>
              <Grid align="left" item xs={10}>
                <Typography  dangerouslySetInnerHTML={{ __html: instance.Activities.Activity.Instructions }} />
              </Grid>
            </Grid>
          )}
        <Grid container align="center" item xs={12} lg={2}>
           { /* CKey-112 : Hide Navigation */ }
           { navenable ? (
          <Grid item xs={6}>
            {index === 0 ? (
              ''
            ) : (
              <Link to={prevPath1} state={links}>
                <Tooltip title="Previous">
                  <div className="icon" style={{ cursor: 'pointer', color: '#2a4d69' }}>
                    <ArrowLeftIcon
                      fontSize="large"
                      onClick={() => {
                        setCheck(false);
                        setView(false);
                        setResult(false);
                        setResubmitCount(prev => prev + 1);
                        // setNewVal(baseVal);
                        window.tinyMCE.activeEditor?.setContent(baseVal);
                        const editor = window.tinymce.activeEditor;
                        if (editor && editor.mode && typeof editor.mode.set === 'function') {
                          editor.mode.set('design');
                        } else {
                          console.error(
                            'Editor is not initialized or mode.set function is not available'
                          );
                        }
                      }}
                    />
                  </div>
                </Tooltip>
              </Link>
            )}
          </Grid>
           ) : ''}
          { /* CKey-112 */}
          { navenable ? (
            process.env.REACT_APP_ENV === 'development' ? (
            <Grid item xs={6}>
              {index === links?.links?.length || links?.links[0]?.id === links?.links[index + 1]?.id ? (
                ''
              ) : (
                <Link to={nextPath} state={links}>
                  <Tooltip title="Next">
                    <div className="icon" style={{ cursor: 'pointer', color: '#2a4d69' }}>
                      <ArrowRightIcon
                        fontSize="large"
                        onClick={() => {
                          setCheck(false);
                          setView(false);
                          setResult(false);
                          // setNewVal(baseVal);
                          window.tinyMCE.activeEditor?.setContent(baseVal);
                          const editor = window.tinymce.activeEditor;
                          if (editor && editor.mode && typeof editor.mode.set === 'function') {
                            editor.mode.set('design');
                          } else {
                            console.error(
                              'Editor is not initialized or mode.set function is not available'
                            );
                          }
                        }}
                      />
                    </div>
                  </Tooltip>
                </Link>
              )}
            </Grid>
          ) : (
            <Grid item xs={6}>
              {index === links?.links?.length - 1 ? (
                ''
              ) : (
                <Link to={nextPath} state={links}>
                  <Tooltip title="Next">
                    <div className="icon" style={{ cursor: 'pointer', color: '#2a4d69' }}>
                      <ArrowRightIcon
                        fontSize="large"
                        onClick={() => {
                          setCheck(false);
                          setView(false);
                          setResult(false);
                          // setNewVal(baseVal);
                          window.tinyMCE.activeEditor?.setContent(baseVal);
                          const editor = window.tinymce.activeEditor;
                          if (editor && editor.mode && typeof editor.mode.set === 'function') {
                            editor.mode.set('design');
                          } else {
                            console.error(
                              'Editor is not initialized or mode.set function is not available'
                            );
                          }
                        }}
                      />
                    </div>
                  </Tooltip>
                </Link>
              )}
            </Grid>
         )
         ) : '' }
        </Grid>
      </Grid>
    </Box>
  );
  const handlePreviousClick = () => {
    if (!result) {
      setSecondFlag(true);
      setTimeout(() => handlePreviousWarningOpen(), 1000);
    } else {
      // Find the previous visible exercise
      const prevVisibleLink = [...(links?.links || [])]
        .slice(0, index)
        .reverse()
        .find(item => item.visible === 1);

      if (prevVisibleLink) {
        const prevLink = prevVisibleLink.name?.split(' ').includes('Document')
          ? `/courses/editor/${replaced(prevVisibleLink.name)}-${replaced(prevVisibleLink.id)}`
          : `/courses/typing/${replaced(prevVisibleLink.name)}-${replaced(prevVisibleLink.id)}`;

        navigate(prevLink, { state: links });
        setCheck(false);
        setView(false);
        setResult(false);
        window?.tinyMCE?.activeEditor?.setContent(baseVal);

        const editor = window?.tinyMCE?.activeEditor;
        if (editor && editor.mode && typeof editor.mode.set === 'function') {
          editor.mode.set('design');
        } else {
          console.error('Editor is not initialized or mode.set function is not available');
        }
      } else {
        console.warn('No previous visible exercise found');
      }
    }
  };
  // CKey-112
  const NewHeaderComp = () => ( navenable &&
    <Box>
      <Grid container align="center" item xs={12}>
        <Grid item xs={4}>
          <>
            <Tooltip title="Previous">
              <div className="icon" style={{ cursor: 'pointer', color: '#2a4d69' }}>
                <ArrowLeftIcon fontSize="large" onClick={() => handlePreviousClick()} />
              </div>
            </Tooltip>
            {/* {if(openPrevious){

            }} */}
            <Dialog
              open={openPrevious}
              onClose={handlePreviousWarningClose}
              aria-labelledby="warning-dialog-title"
              aria-describedby="warning-dialog-description"
              PaperProps={{
                sx: {
                  borderRadius: '25px' // Apply border radius here
                }
              }}>
              <DialogTitle
                id="warning-dialog-title"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={warningIcon} alt="Warning" style={{ width: '50px', height: '50px' }} />
              </DialogTitle>
              <DialogContent>
                By navigating away from the current activity, you are allowed to delete your attempt
                and work will not be saved. Are you sure you want to do this now?
              </DialogContent>
              <DialogActions>
                <Button onClick={handlePreviousWarningClose} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    const prevVisibleLink = [...(links?.links || [])]
                      .slice(0, index)
                      .reverse()
                      .find(item => item.visible === 1);

                    const prevLink = prevVisibleLink.name?.split(' ').includes('Document')
                      ? `/courses/editor/${replaced(prevVisibleLink.name)}-${replaced(
                          prevVisibleLink.id
                        )}`
                      : `/courses/typing/${replaced(prevVisibleLink.name)}-${replaced(
                          prevVisibleLink.id
                        )}`;

                    navigate(prevLink, { state: links });
                    setCheck(false);
                    setView(false);
                    setResult(false);
                    // setNewVal(baseVal);
                    window?.tinyMCE?.activeEditor?.setContent(baseVal);
                    const editor = window?.tinyMCE?.activeEditor;
                    if (editor && editor.mode && typeof editor.mode.set === 'function') {
                      editor.mode.set('design');
                    } else {
                      console.error(
                        'Editor is not initialized or mode.set function is not available'
                      );
                    }
                    handlePreviousWarningClose();
                  }}>
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </>
        </Grid>
        <Grid item xs={4}>
          <Tooltip title="New Graded Attempt">
            <div className="icon">
              <ReplayIcon
                fontSize="medium"
                onClick={e => {
                  window.location.reload();
                }}
              />
            </div>
          </Tooltip>
        </Grid>
        {process.env.REACT_APP_ENV === 'development' ? (
          <Grid item xs={4}>
            {index === links?.links?.length || links?.links[0]?.id === links?.links[index + 1]?.id ? (
              ''
            ) : (
              <>
                <Tooltip title="Next">
                  <div className="icon" style={{ cursor: 'pointer', color: '#2a4d69' }}>
                    <ArrowRightIcon
                      fontSize="large"
                      onClick={() => {
                        if (!result) {
                          setSecondFlag(true);
                          setTimeout(() => handleWarningOpen(), 1000);
                        } else {
                          setCheck(false);
                          setView(false);
                          setResult(false);
                          // setNewVal(baseVal);
                          window?.tinyMCE?.activeEditor?.setContent(baseVal);
                          const editor = window?.tinyMCE?.activeEditor;
                          if (editor && editor.mode && typeof editor.mode.set === 'function') {
                            editor.mode.set('design');
                          } else {
                            console.error(
                              'Editor is not initialized or mode.set function is not available'
                            );
                          }
                          handleNavigateAway();
                        }
                      }}
                    />
                  </div>
                </Tooltip>
                <Dialog
                  open={open}
                  onClose={handleWarningClose}
                  aria-labelledby="warning-dialog-title"
                  aria-describedby="warning-dialog-description"
                  PaperProps={{
                    sx: {
                      borderRadius: '25px' // Apply border radius here
                    }
                  }}>
                  <DialogTitle
                    id="warning-dialog-title"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img
                      src={warningIcon}
                      alt="Warning"
                      style={{ width: '50px', height: '50px' }}
                    />
                  </DialogTitle>
                  <DialogContent>
                    By navigating away from the current activity, you are allowed to delete your
                    attempt and work will not be saved. Are you sure you want to do this now?
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleWarningClose} color="primary">
                      Cancel
                    </Button>
                    <Button
                      onClick={() => {
                        handleWarningClose(); // Close the dialog
                        setCheck(false);
                        setView(false);
                        setResult(false);
                        // setNewVal(baseVal);
                        window?.tinyMCE?.activeEditor?.setContent(baseVal);
                        const editor = window?.tinyMCE?.activeEditor;
                        if (editor && editor.mode && typeof editor.mode.set === 'function') {
                          editor.mode.set('design');
                        } else {
                          console.error(
                            'Editor is not initialized or mode.set function is not available'
                          );
                        }
                        handleNavigateAway(); // Trigger navigation
                      }}>
                      OK
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            )}
          </Grid>
        ) : (
          <Grid item xs={4}>
            {index === links?.links?.length - 1 ? (
              ''
            ) : (
              <Link to={nextPath} state={links}>
                <Tooltip title="Next">
                  <div className="icon" style={{ cursor: 'pointer', color: '#2a4d69' }}>
                    <ArrowRightIcon
                      fontSize="large"
                      onClick={() => {
                        setCheck(false);
                        setView(false);
                        setResult(false);
                        // setNewVal(baseVal);
                        window.tinyMCE.activeEditor?.setContent(baseVal);
                        const editor = window.tinymce.activeEditor;
                        if (editor && editor.mode && typeof editor.mode.set === 'function') {
                          editor.mode.set('design');
                        } else {
                          console.error(
                            'Editor is not initialized or mode.set function is not available'
                          );
                        }
                      }}
                    />
                  </div>
                </Tooltip>
              </Link>
            )}
          </Grid>
        )}
        <div className={classes.buttonOutline}>
          { /* CKey-112: Hide Navigation */ }
          { navenable && lastID === Number(instanceID) ? (
            <Button
              onClick={() => fetchExercises(location.state?.courseID)}
              className={classes.button}
              variant="outlined">
              Next Session
            </Button>
          ) : (
            <></>
          )}
        </div>
        {result ? (
          <>
            {/* <Button
              className={classes.button}
              variant="outlined"
              onClick={() => {
                setCheck(false);
                checkval();
              }}>
              Results
            </Button>{' '} */}

            {instance?.Activities?.Activity?.attributes?.DisplayWAM === 'true' && (
              <Box className="ResultCard_Box">
                <Typography className="ResultCard_BoxInfo" variant="inherit">
                  Words per minute
                </Typography>
                <Typography
                  sx={{ color: '#eb6060', fontWeight: 'bold' }}
                  align="center"
                  variant="inherit">
                  {Math.round(count / (seconds / 60))}
                </Typography>
              </Box>
            )}

            {check ? (
              <>
                {instance?.Activities?.Activity?.attributes?.DisplayErrors === 'True' && (
                  <Box className="ResultCard_Box">
                    <Typography className="ResultCard_BoxInfo">Errors</Typography>
                    {
                    <Typography
                      sx={{ color: '#eb6060', fontWeight: 'bold' }}
                      align="center"
                      variant="inherit">
                      {docError}
                    </Typography>
                    /*
                    <Grid>
                      <span style={{ color: 'red', background: '#fec4c0', fontSize: 'small' }}>
                        Remove the selected item
                      </span>
                    </Grid>
                    <Grid>
                      <span style={{ color: 'blue', background: '#abcbff', fontSize: 'small' }}>
                        Add the item
                      </span>
                    </Grid>
                    <Grid>
                      <span style={{ color: 'green', background: '#87ffa7', fontSize: 'small' }}>
                        Alignment and style error
                      </span>
                    </Grid>
                    */}
                  </Box>
                )}
                <Box className="ResultCard_Box">
                  <Typography className="ResultCard_BoxInfo" variant="inherit">
                    Words Per Minute
                  </Typography>
                  <Typography
                    sx={{ color: '#eb6060', fontWeight: 'bold' }}
                    align="center"
                    variant="inherit">
                    {/* {isNaN(wpm) ? 0 : wpm} */}
                    {wpm}
                  </Typography>
                </Box>
                <Box className="ResultCard_Box">
                  <Typography className="ResultCard_BoxInfo" variant="inherit">
                    Percentage
                  </Typography>
                  <Typography
                    sx={{ color: '#eb6060', fontWeight: 'bold' }}
                    align="center"
                    variant="inherit">
                    {/* {isNaN(wpm) ? 0 : wpm} */}
                    {fixedPercentage}
                  </Typography>
                </Box>
              </>
            ) : (
              ''
            )}
          </>
        ) : (
          ' '
        )}
      </Grid>
    </Box>
  );
  const handleEditorChange = e => {
    var newContent = e.target.getContent(); // postprocess the HTML before setting the new value
    newContent = newContent.replace(/(&nbsp;|\u00A0)(?=<(?:b|strong|i|em)>)/g, " "); // non-breaking spaces become standard spaces
    newContent = newContent.replace(/--/g, "—"); // double hyphens become em-dashes

    //Remove in-line styling from html tables so html to word doc conversion doesn't fail
    // newContent = newContent.replace(/<td[^>]*>/g, "<td>");//remove any inline style for tag
    // newContent = newContent.replace(/<th[^>]*>/g, "<th>");//remove any inline style for tag
    // newContent = newContent.replace(/<tr[^>]*>/g, "<tr>");//remove any inline style for tag
    // newContent = newContent.replace(/<table[^>]*>/g, "<table>");//remove any inline style for tag
    // newContent = newContent.replace(/<thead[^>]*>/g, "<thead>");//remove any inline style for tag
    // newContent = newContent.replace(/<tbody[^>]*>/g, "<tbody>");//remove any inline style for tag

    setNewVal(newContent);
    // console.log(e.target.getContent());
    // console.log(newVal);
  };
      
  /*
      Export2Word(
        exportMoodObj.percent,
        err,
        exportMoodObj.string,
        exportMoodObj.string2,
        exportMoodObj.base64String,
        resultDocFile,
        transactionId // SJK: CKey-101
      );
    */
  async function Export2Word(
    percent,
    err,
    string,
    string2,
    base64String,
    finalText,
    filename = '',
    transactionId 
  ) {
    var preHtml =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    var postHtml = '</body></html>';
    var html = preHtml + newVal + postHtml;
    var blob = new Blob(['\ufeff', html], {
      type: 'application/msword'
    });
    // Specify file name
    filename = filename ? 'index' + '.doc' : 'document.doc';
    const userId = userContext?.userData?.id || localStorage.getItem('userid');
    const userName = userContext?.userData?.fullname || localStorage.getItem('username');
    const userEmail = userContext?.userData?.email || localStorage.getItem('userEmail');

    var formData = new FormData();
    formData.append('object', blob, filename);
    formData.append('id', userId);
    formData.append('name', userName);
    formData.append('email', userEmail);
    formData.append(
      'courseID',
      location?.state?.courseID && location.state.courseID !== 'undefined'
        ? location.state.courseID
        : sessionStorage.getItem('activityInstance')
    );
    formData.append('testID', InstanceId);
    formData.append('exptdlink', instance.Activities.Activity.attributes.ModelFileLocation);
    formData.append('errors', err);
    formData.append(
      'result',
      JSON.stringify({
        exName: instance.Activities.Activity.Label + ' ' + instance.Activities.Activity.Title,
        wpm: Math.round(
          window?.tinyMCE?.activeEditor.plugins.wordcount.getCount() / (seconds / 60)
        ),
        timetaken: seconds,
        wordcount: window?.tinyMCE?.activeEditor.plugins.wordcount.getCount(),
        error: err,
        percentage: percent.toFixed(4) * 100
      })
    );
    formData.append('examtime', new Date().toISOString());
    // SJK : CKey-101
    formData.append('transid', transactionId);
    // add moodle api
    sendDataToMood(
      userId,
      InstanceId,
      Math.round(window?.tinyMCE?.activeEditor.plugins.wordcount.getCount() / (seconds / 60)),
      seconds,
      err,
      percent.toFixed(4) * 100,
      window?.tinyMCE?.activeEditor.plugins.wordcount.getCount(),
      string,
      instance.Activities.Activity.Label + '.docx',
      finalText,
      string2,
      // base64String , SJK: CKey-101
      transactionId  // SJK : CKey-101
    );
    const res = await axios({
      url: '/api/uploads',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      formData,
      data: formData
    });
  }

  const styles = {
    added: {
      color: 'blue',
      backgroundColor: '#abcbff'
    },
    removed: {
      color: 'red',
      backgroundColor: '#fec4c0'
    },

    align: {
      color: 'green',
      backgroundColor: '#87ffa7'
    }
  };
  function stripHtml(html) {
    let tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
  function countWords(str) {
    str = str.replace(/(^\s*)|(\s*$)/gi, '');
    str = str.replace(/[ ]{2,}/gi, ' ');
    str = str.replace(/\n /, '\n');
    return str.split(' ').length;
  }
  const Diff = async ({ string1 = '', string2 = '', mode = 'characters' }) => {
    let check = false;
    let str = string2.replace(/p><p>/g, 'p>\n<p>');
    str = str.replace(/></g, '>\n<');
    let groups = [];
    let intcount = 0;
    let actualError = 0;
    string1 = string1.replace(/&rsquo;/g, "'");
    string1 = string1.replace(/&ldquo;/g, '"');
    string1 = string1.replace(/&rdquo;/g, '"');
    string1 = string1.replace(/&mdash;/g, '-');

    // string1 = str.replace(/&rsquo;/g, `'`);
    // string1 = str.replace(/&rsquo;/g, `'`);

    if (mode === 'characters') groups = diff.diffChars(string1, str);
    if (mode === 'words') groups = diff.diffWordsWithSpace(string1, str);
    setPercentage(similarity(string1, str));
    const mappedNodes = groups.map(group => {
      let error = '';

      let moreError = stripHtml(group.value);
      // console.log(moreError);

      // if (countWords(moreError) > 10) {
      //   actualError = countWords(moreError);
      // }
      // var wordCount = moreError.match(/(\w+)/g).length;
      // console.log(wordCount);
      const { value, added, removed } = group;
      let nodeStyles;
      if (check) {
        nodeStyles = styles.align;
        error = 'style and alignment';
        check = false;
      }
      if (added) {
        nodeStyles = styles.added;
        error = 'add the item';

        // if (group.value == '<em>' || group.value == '<strong>' || group.value == '\n') {
        //   intcount;
        // } else {
        //   intcount++;
        // }
      }

      if (removed) {
        if (
          group.value == '<em>' ||
          group.value == '<strong>' ||
          group.value == ' style="text-align: right;"'
        ) {
          check = true;
        } else {
          nodeStyles = styles.removed;
          error = 'change the item';
        }

        if (group.value == '<em>' || group.value == '<strong>' || group.value == '\n') {
          intcount;
        } else {
          intcount++;
        }
      }
      // console.log(error);

      return (
        <span key={value} style={nodeStyles}>
          {typeof nodeStyles !== 'undefined' && (value !== '</em>' || value != '</strong>')
            ? `<span style="color: ${nodeStyles?.color}; background-color: ${nodeStyles?.backgroundColor};">${value}<sup>${error}</sup></span>`
            : value}
          {/* {`<span>${nodeStyles}<span>${value}`} */}
          {/* {`<span style="color: ${nodeStyles?.color}; background-color: ${nodeStyles?.backgroundColor};">${value}<sup>${error}</sup></span>`} */}
        </span>
      );
    });
    // console.log(diff.applyPatch(string1, string2));
    // mappedNodes.map((val, i) => {
    //   console.log(val);
    //   console.log(i);
    //   if (val.props.children == '<em>') {
    //     console.log(val.props.children);
    //     mappedNodes[i + 1].props.style = styles.align;
    //   }
    // });
    // console.log(intcount);
    // console.log(mappedNodes);
    SetTotalerror(intcount + actualError);
    // console.log(percentage);
    // console.log(totalerror);
    Setfinal(innerText(<div>{mappedNodes}</div>));
    // SJK: CKey-117: Function to convert percent to px
    function convertPercentWidthsToPx(html, tableWidth = 600) {
    const updated = html.replace(
      /width\s*:\s*([\d.]+)%/gi,
      (_, percent) => {
        const px = Math.round((parseFloat(percent) / 100) * tableWidth);
        return `width:${px}px`;
      }
    );
    return updated;
  }

    let base64String = '';
    try {
      // SJK: CKey-104 : Replace required emoji symbol to other during conversion
      let updateNewVal = newVal.replaceAll( '❌', '<span style="font-family:\'Segoe UI Symbol\'; font-size:11pt;">🗙</span>');
      const response = await fetch('/html-docx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          // SJK: CKey-117: convert percent to px to retain width
          // html: newVal,
          html: convertPercentWidthsToPx(updateNewVal),
          uid: userContext?.userData?.id || localStorage.getItem('userid'),
          activityName: window.location.pathname.split("/").pop()
        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const base64String = data.base64Docx;

      //JG Add logic to check if doc activity is compare or non-compare
      if(instance.Activities.Activity.attributes.DPAType === "Ungraded") {
        let userId = userContext?.userData?.id || localStorage.getItem('userid');
        let wam = Math.round(window?.tinyMCE?.activeEditor.plugins.wordcount.getCount() / (seconds / 60));
        let wordCount = window?.tinyMCE?.activeEditor.plugins.wordcount.getCount();
        let doc = instance.Activities.Activity.Label + '.docx';
        console.log("Skipping word compare api call for Ungraded document activity");
        setDocBase64Content(base64String);
        // SJK : CKey-101 : Add extra param null
        sendDataToMood(userId, InstanceId, wam, seconds, 0, null, wordCount, base64String, doc, null, null, null);
      }
      else {
        handleGenerate(base64String, {
          percent: similarity(string1, str),
          err: intcount + actualError,
          string: string1,
          string2: string2,
          base64String: base64String
        });
      }

      return <div>{mappedNodes}</div>;
    } catch (error) {
      console.error('Error downloading the document:', error);
    }
  };

  Diff.propTypes = {
    string1: PropTypes.string,
    string2: PropTypes.string,
    mode: PropTypes.oneOf(['characters', 'words'])
  };

  function similarity(s1, s2) {
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
      longer = s2;
      shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength == 0) {
      return 1.0;
    }
    return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
  }

  function editDistance(s1, s2) {
    //s1 = s1.toLowerCase();
    //s2 = s2.toLowerCase();

    var costs = new Array();
    for (var i = 0; i <= s1.length; i++) {
      var lastValue = i;
      for (var j = 0; j <= s2.length; j++) {
        if (i == 0) costs[j] = j;
        else {
          if (j > 0) {
            var newValue = costs[j - 1];
            if (s1.charAt(i - 1) != s2.charAt(j - 1))
              newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
            costs[j - 1] = lastValue;
            lastValue = newValue;
          }
        }
      }
      if (i > 0) costs[s2.length] = lastValue;
    }
    return costs[s2.length];
  }

  const handleReset = async() => {
    if (instance?.Activities?.Activity?.attributes?.BaseFileLoc) {
      await axios.post(
        `api/word`,
        {url: instance.Activities.Activity.attributes.BaseFileLoc}
      ).then(function (response) {
        const formattedContent = response.data.data
          .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;') // Replace tabs with four non-breaking spaces
          .replace(/ {2}/g, '&nbsp;&nbsp;') // Replace double spaces with non-breaking spaces
          .replace(/\n/g, '<br />'); // Replace newlines with <br>
        if (result) setResult(false);
        setBaseVal(formattedContent);
        window.tinyMCE.activeEditor?.setContent(formattedContent || '');
      }).catch(function (error) {
        console.error(error);
      });
    }
  };

  const viewEditor = async () => {
    setView(true);
    if (instance) {
      let oldSubmission;
      await fetch('/previousSubmission', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          uid: userContext?.userData?.id || localStorage.getItem('userid'),
          activityName: window.location.pathname.split("/").pop()
        })
      })
      .then(res => res.json())
      .then(data => {
        // CKey-104: Replace one symbol for other during fetch of old submission
        oldSubmission = data?.previousSubmission || '' ;
        oldSubmission = oldSubmission.replaceAll( '<span style="font-family:\'Segoe UI Symbol\'; font-size:11pt;">🗙</span>', '❌');
      }).catch(err => {
        console.error('Error fetching previous submission:', err);
      });
      if (oldSubmission) {
        setBaseVal(oldSubmission);
        window.tinyMCE.activeEditor?.setContent(oldSubmission || '');
      } else {
        handleReset();
      }
      if (instance.Activities.Activity.attributes.ModelFileLocation) {
        await axios.post(
          `api/word`,
          {url: instance.Activities.Activity.attributes.ModelFileLocation}
        ).then(function (response) {
          setHtml(response.data.data.base64);
          //console.log(response);
        }).catch(function (error) {
           console.log(error);
          }
        );
      }
    }
  };

  // copy paste in word
  // const handleChange = e => {
  //   e.preventDefault();
  // };
  function toBase64Unicode(str) {
    return btoa(unescape(encodeURIComponent(str)));
  }
  // function base64EncodeUnicode(str) {
  //   const uint8Array = new TextEncoder().encode(str); // Encode string to UTF-8
  //   const base64String = btoa(String.fromCharCode.apply(null, uint8Array)); // Convert byte array to base64
  //   return base64String;
  // }
  const removeClassName = htmlString => {
    // Change className to class to match the HTML
    return htmlString.replace(/class="[^"]*"/g, '');
  };

  // const test = `<p class="MsoNormal">April 8, 2020</p>
  // <p class="MsoNormal"> </p>
  // <p class="MsoNormal">Mr. Mark Shakil, President<br>Dain Bosworth, Inc.<br>2401 Lincoln Boulevard<br>New York, NY 10037-6847</p>
  // <p class="MsoNormal">Dear Mr. Shakil:</p>
  // <p class="MsoNormal">This is to record the mutual intention of M &amp; I Technologies and Waedt-Steiner Investment Services to undertake a public offering of common stock of M &amp; I Technologies (the "company").</p>
  // <p class="MsoNormal">It is our intention to form an underwriting syndicate to purchase up to 250,000 shares of new common stock from M &amp; I Technologies and to reoffer the shares to the public at a price mutually agreed upon. This agreement is subject to the following:</p>
  // <p class="MsoListParagraphCxSpFirst" style="text-indent: -.25in; mso-list: l0 level1 lfo1;"><!-- [if !supportLists]--><span style="font-family: Symbol; mso-fareast-font-family: Symbol; mso-bidi-font-family: Symbol;"><span style="mso-list: Ignore;">&middot;<span style="font: 7.0pt 'Times New Roman';">         </span></span></span><!--[endif]-->The assurance that no materially adverse change in the affairs of the company and its prospects occurs which appears sufficient, in our opinion, to threaten the success of our effort.</p>
  // <p class="MsoListParagraphCxSpMiddle" style="text-indent: -.25in; mso-list: l0 level1 lfo1;"><!-- [if !supportLists]--><span style="font-family: Symbol; mso-fareast-font-family: Symbol; mso-bidi-font-family: Symbol;"><span style="mso-list: Ignore;">&middot;<span style="font: 7.0pt 'Times New Roman';">         </span></span></span><!--[endif]-->The market conditions at the time of the offering.</p>
  // <p class="MsoListParagraphCxSpLast" style="text-indent: -.25in; mso-list: l0 level1 lfo1;"><!-- [if !supportLists]--><span style="font-family: Symbol; mso-fareast-font-family: Symbol; mso-bidi-font-family: Symbol;"><span style="mso-list: Ignore;">&middot;<span style="font: 7.0pt 'Times New Roman';">         </span></span></span><!--[endif]-->The filing of a prospectus with the Securities and Exchange Commission (SEC) and its subsequent notification of effectiveness.</p>
  // <p class="MsoListParagraphCxSpLast" style="text-indent: -.25in; mso-list: l0 level1 lfo1;">TThis is testing!!</p>
  // <p class="MsoListParagraphCxSpLast" style="text-indent: -.25in; mso-list: l0 level1 lfo1;"> </p>
  // <p class="MsoListParagraphCxSpLast" style="text-indent: -.25in; mso-list: l0 level1 lfo1;"> </p>
  // <p class="MsoListParagraphCxSpLast" style="text-indent: -.25in; mso-list: l0 level1 lfo1;"> </p>`;

  // console.log(removeClassName(test));
  const cleanHtmlString = html => {
    // Step 1: Temporarily store <strong>{any content}</strong> parts
    const strongTags = [];
    let correctedHtml = html.replace(/<strong>(.*?)<\/strong>/g, match => {
      // Save the matching <strong>...</strong> content to be excluded from further processing
      strongTags.push(match);
      return `<!-- strong-placeholder-${strongTags.length - 1} -->`; // Replace with a placeholder
    });

    // Step 2: Apply cleaning logic to the rest of the HTML
    correctedHtml = correctedHtml.replace(/(?<!<)p>(?!<\/p>)/g, ''); // Step 1: Remove stray p> (not <p> or </p>)
    correctedHtml = correctedHtml
      .replace(/<\s*su\s*>/g, '<sup>') // Step 2: Correct <su> to <sup>
      .replace(/<\/\s*su\s*>/g, '</sup>');

    correctedHtml = correctedHtml
      .replace(/<\s*br\s*>/g, '<br />') // Step 3: Correct <br> tags to be self-closing (<br />)
      .replace(/<\s*span\s*>(<br \/>|<br>)<\/\s*span\s*>/g, '$1'); // Remove span wrappers around <br>

    correctedHtml = correctedHtml.replace(/<br\s*<span/g, '<br /><span'); // Step 4: Correct <br><span to <br /><span>

    correctedHtml = correctedHtml.replace(/<\s*spa[^>]*>(.*?)<\/\s*spa\s*>/g, '$1'); // Step 5: Remove <spa> tags

    correctedHtml = correctedHtml.replace(/<span>(\s*)<\/span>/g, ''); // Step 6: Remove empty spans
    correctedHtml = correctedHtml.replace(/<span>\s*<\/span>/g, ''); // Remove spans around only whitespace

    correctedHtml = correctedHtml.replace(/<([a-zA-Z0-9]+)([^>]*)>(?!.*<\/\1>)/g, '<$1$2></$1>'); // Step 7: Ensure tags are closed properly

    correctedHtml = correctedHtml.replace(/(<([^>]+)>)/g, (match, p1) => {
      return /^<\/?[a-zA-Z][^>]*>$/.test(p1) ? p1 : ''; // Step 8: Remove stray < or > characters
    });

    correctedHtml = correctedHtml.replace(/<([a-zA-Z0-9]+)([^>]*)>(?!.*<\/\1>)/g, '<$1$2></$1>'); // Step 9: Ensure remaining unclosed tags are closed

    // Step 3: Append the new paragraph with specified content (Step 10)
    const newParagraph = `
      <p>
        <span style="color: red; background-color: #fec4c0;">Remove the selected item</span><br />
        <span style="color: blue; background-color: #abcbff;">Add the item</span><br />
        <span style="color: green; background-color: #c8f8c8;">Alignment and style error</span>
      </p>
    `;
    correctedHtml += newParagraph;

    // Step 4: Reinsert the previously stored <strong>{any content}</strong> content
    strongTags.forEach((strongTag, index) => {
      correctedHtml = correctedHtml.replace(`<!-- strong-placeholder-${index} -->`, strongTag);
    });

    return correctedHtml;
  };

  // Example usage
  // const htmlInput = '<p>Some text <su>example</su> with <br<span>text</span></p>';
  // const cleanedHtml = cleanHtmlString(htmlInput);
  // console.log(cleanedHtml);

  const refineFinalText = rawText => {
    // Sanitize the HTML string
    // const cleanHTML = DOMPurify.sanitize(rawText);

    // Encode the sanitized string
    const base64String = btoa(String.fromCharCode(...new TextEncoder().encode(rawText)));

    return base64String;
  };

  useEffect(async () => {
    if (callPostResultApi && docBase64Content?.length > 0 && dataForSendingToMoodle) {
      let {
        userId,
        instanceId,
        wam,
        timeTaken,
        error,
        percent,
        wordcount,
        string,
        doc,
        finalText,
        string2,
        transactionId // SJK : CKey-101
      } = dataForSendingToMoodle;
      // Modify the doc name to the required format
      const modifiedDoc = doc.replace(':', '_result');

      // const refinefinalText = cleanHtmlString(finalText);
      // const base64String = toBase64Unicode(refinefinalText);
      // const refinedBase64String = refineFinalText(refinefinalText);
      // console.log(refinedBase64String);

      const stringWithoutClassName = removeClassName(string);

      const base64StringResult = toBase64Unicode(stringWithoutClassName);
      const base64OriginalHtml = toBase64Unicode(string);
      // console.log(cleanedStringResult);
      // console.log(cleanedString);
      // console.log(refinefinalText);
      const courseIDSelected =
        localStorage.getItem('courseIdselected') &&
        localStorage.getItem('courseIdselected') !== 'undefined'
          ? localStorage.getItem('courseIdselected')
          : sessionStorage.getItem('activityInstance');

      let xmlData2 = ``;

      if(instance.Activities.Activity.attributes.DPAType === "Ungraded") {
        //console.log("Build non gradeable xml");
        // Construct the XML body
        xmlData2 = `
        <ResultXml>
            <CourseId>${courseIDSelected}</CourseId>
          <UserId>${userId}</UserId>
            <ActivityResult>
              <ActivityId>${instanceId}</ActivityId>
              <WAM>${wam}</WAM>
                <Time></Time>
              <TimeTaken>${timeTaken}</TimeTaken>
              <GradeableAttempt>false</GradeableAttempt>
              <File>
                <Contents>${docBase64Content}</Contents>
                <Name>${doc}</Name>
                <Size>${docBase64Content.length}</Size>
                <WordVersion>Tiny MCE V6</WordVersion>
              </File>
              <RawFile>
                <Contents>${base64OriginalHtml}</Contents>
                <Name>${modifiedDoc.replace('.docx', '.html')}</Name>
                <Size>${string.length}</Size>
                <WordVersion>TinyMCE</WordVersion>
              </RawFile>
              <TransId>${transactionId}</TransId>
            </ActivityResult>
        </ResultXml>`;
      }
      else {
        //console.log("Build gradeable xml");
        // Construct the XML body
        xmlData2 = `
        <ResultXml>
            <CourseId>${courseIDSelected}</CourseId>
          <UserId>${userId}</UserId>
            <ActivityResult>
              <ActivityId>${instanceId}</ActivityId>
              <WAM>${wam}</WAM>
                <Time></Time>
              <TimeTaken>${timeTaken}</TimeTaken>
              <TotalErrors>${error}</TotalErrors>
              <GradeableAttempt>true</GradeableAttempt>
                <UserInput/>
                <ResultText/>
                <Keys>
                    <Key>
                        <AverageTime>${Number.isFinite(timeTaken) ? timeTaken : 0}</AverageTime>
                        <Char></Char>
                        <PercentCorrect>${percent}</PercentCorrect>
                        <Count>${wordcount}</Count>
                    </Key>
                </Keys>
              <File>
              <Contents>${docBase64Content}</Contents>
              <Name>${doc}</Name>
              <Size>0</Size>
              <WordVersion>Tiny MCE V6</WordVersion>
              </File>
              <ResultFile>
                      <Contents>${finalText}</Contents>
                      <Name>${modifiedDoc}</Name>
              </ResultFile>
              <RawFile>
                <Contents>${base64OriginalHtml}</Contents>
                <Name>${modifiedDoc.replace('.docx', '.html')}</Name>
                <Size>${string.length}</Size>
                <WordVersion>TinyMCE</WordVersion>
              </RawFile>
              <TransId>${transactionId}</TransId> 
            </ActivityResult>
        </ResultXml>`;
      }

      
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_MOODLE_DEVELOPMENT_URL}/mod/kb/appservice_kbws.php?action=postresult`,
          xmlData2,
          {
            headers: {
              'Content-Type': 'application/xml'
            }
          }
        );

        // const res = await axios({
        //   url: '/api/logs',
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json'
        //   },
        //   data: {
        //     user: userId,
        //     time: Date.now(),
        //     activity: instanceId,
        //     message: "JG Testing Logger",
        //   }
        // });


      } catch (error) {
        console.error('Error:', error);
        //logging error to KB App DB 
        const res = await axios({
          url: '/api/logs',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            user: userId,
            time: Date.now(),
            activity: xmlData2,
            message: error,
          }
        });
      }
    }
  }, [callPostResultApi, docBase64Content, dataForSendingToMoodle]);

  const sendDataToMood = async (
    userId,
    instanceId,
    wam,
    timeTaken,
    error,
    percent,
    wordcount,
    string,
    doc,
    finalText,
    string2,
    transactionId // SJK : CKey-101
  ) => {
    setDataForSendingToMoodle({
      userId,
      instanceId,
      wam,
      timeTaken,
      error,
      percent,
      wordcount,
      string,
      doc,
      finalText,
      string2,
    transactionId // SJK : CKey-101
    });
    setCallPostResultApi(true);
  };

  return (
    <TypingContainer
      title={
        instance
          ? `${instance.Activities.Activity.Label} ${instance.Activities.Activity.Title}`
          : ''
      }
      attributes={
        instance?.Activities?.Activity && instance?.Activities?.Activity?.attributes
          ? instance?.Activities?.Activity?.attributes
          : ''
      }>
      {' '}
      {view ? (
        <Grid container align="center" item xs={12} lg={12}>
          <Grid item xs={check ? 5 : 10}>
            <Editor
              initialValue={baseVal}
              onChange={handleEditorChange}
              onKeyDown={() => {
                if (!typingStarted && time == 0) {
                  setTypingStarted(true);
                  // console.log('typing started');
                }
              }}
              data-enable-grammarly="false"
              init={{
                selector: 'textarea',
                height: 500,
                menubar: true,
                nonbreaking_force_tab: true,
                etd_file_name: 'tinymce-content',
                // browser_spellcheck: false, // Disable browser's spell check
                // gecko_spellcheck: false, // Disable Firefox spell check
                setup: editor => {
                  editor.on('init', () => {
                    editor.getDoc().body.setAttribute('spellcheck', 'false');
                    editor.getDoc().body.setAttribute('data-enable-grammarly', 'false');
                  });
                // CKey-105: To preserve empty editor properities and line height on enter key
                const formattingState = new Map();
                editor.on('ExecCommand', (e) => {
                    if (editor.getBody().textContent.trim() !== '') {
                        return;
                    }
                    if (!e.command || ['mceFocus', 'Undo', 'Redo', 'SelectAll'].includes(e.command)) {
                        return;
                    }
                    formattingState.set(e.command, e.value);
                });
                editor.on('keydown', e => {
                    if (e.key !== 'Enter') {
                        return;
                    }
                    if (editor.getBody().textContent.trim() !== '') {
                        return;
                    }
                    // Capture line-height from the current paragraph
                    const currentBlock = editor.selection.getStart().closest('p');
                    if (currentBlock?.style.lineHeight) {
                        formattingState.set(
                            '__lineHeight',
                            currentBlock.style.lineHeight
                        );
                    }
                    const snapshot = new Map(formattingState);
                    requestAnimationFrame(() => {
                        snapshot.forEach((value, command) => {
                            if (command === '__lineHeight') {
                                const newBlock = editor.selection.getStart().closest('p');
                                if (newBlock) {
                                    newBlock.style.lineHeight = value;
                                }
                                return;
                            }
                            editor.execCommand(command, false, value);
                        });
                        editor.nodeChanged();
                    });
                }); 
                // CKey-121: Preserve bullet style on top-level outdent
                editor.on('BeforeExecCommand', (e) => {
                    if (e.command.toLowerCase() !== 'outdent') {
                        return;
                    }               
                    const node = editor.selection.getNode();               
                    let list = node;               
                    if (node.nodeName !== 'UL' && node.nodeName !== 'OL') {
                        list = editor.dom.getParent(node, 'ul,ol');
                    }               
                    if (!list) {
                        return;
                    }               
                    const isTopLevel =
                        list.parentNode &&
                        list.parentNode.nodeName.toUpperCase() !== 'LI';               
                    if (!isTopLevel) {
                        return;
                    }               
                    e.preventDefault();
                    e.stopPropagation();               
                    editor.dom.setStyles(list, {
                        marginLeft: '0',
                        paddingLeft: '20px'
                    });                
                    return false;
                });
                },
                plugins: [
                  'advlist',
                  'autolink',
                  'lists',
                  'link',
                  'image',
                  'charmap',
                  'print',
                  'preview',
                  'anchor',
                  'help',
                  'searchreplace',
                  'visualblocks',
                  'code',
                  'insertdatetime',
                  'media',
                  'paste',
                  'wordcount',
                  'table',
                  'nonbreaking',
                  'customborder', // Include your custom plugin here
                  'pagebreak',
                  'customhf',
                  'extendedlists', // Include the extendedlists plugin
                  'symbolpicker',
                  'hr',
                  'custommargin',
                  'customcolumns',
                  'footnotes',
                  'customfolder',
                  'tablesorting'
                ],
                toolbar1:
                  'undo redo | insert | styleselect fontsize | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | superscript subscript | customhr customvr | customheader customfooter | symbolpicker  | custommargin | customcolumns | footnotes | customfolder |  sortasc sortdesc',
                content_style: `
    body { font-family:Helvetica,Arial,sans-serif; font-size:14px }
          .footnote { margin-top: 10px; font-size: 12px; }
          .footnote-ref a { text-decoration: none; }
          .footnotes-container { margin-top: 20px; }
          .footnotes-separator { border: 0; border-top: 1px solid #000; margin-bottom: 10px; }
          .folder {
            margin: 10px 0;
            border: 1px solid #ccc;
            border-radius: 4px;
          }
          .folder-header {
            padding: 10px;
            background-color: #f4f4f4;
            cursor: pointer;
            user-select: none;
          }
          .folder-content {
            padding: 10px;
            display: none;
          }
          .folder-content.open {
            display: block;
          }
  `,
                toolbar2:
                  'print preview media | forecolor backcolor emoticons | codesample help | pagebreak | hr'
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <NewHeaderComp />
            {!result && (
              <Button
                className={classes.button}
                variant="outlined"
                onClick={handleReset}
                disabled={loading} // Disable the button while loading
              >
                {loading ? <CircularProgress size={20} /> : 'Reset'}
              </Button>
            )}
            <Button
              className={result ? classes.buttonClick : classes.button}
              variant="outlined"
              disabled={result}
              onClick={async () => {
                if (newVal == undefined) {
                  alert('Please make any changes to submit ');
                } else {
                  setResult(true);
                  setLoading(true);
                  setTypingStarted(false);
                  // console.log('typing stoped at time = ', time);
                  Diff({ string1: newVal.replace(/&nbsp;/g, ' '), string2: html, mode: 'words' });
                  const editor = window?.tinyMCE?.activeEditor;
                  if (editor && editor.mode && editor.mode.get() === 'design') {
                    editor.mode.set('readonly');
                  } else {
                    console.error(
                      'Editor is not initialized or mode.set function is not available'
                    );
                  }
                  var theEditor = window?.tinyMCE?.activeEditor;
                  setCount(theEditor.plugins.wordcount?.getCount() ?? 1);
                }
              }}>
              {result ? 'Submitted' : 'Submit'}
            </Button>{' '}
            {!result || html === undefined ? (
              ''
            ) : (
              <Button
                className={classes.button}
                variant="outlined"
                onClick={handleClick}
                disabled={loading} // Disable the button while loading
              >
                {loading ? <CircularProgress size={20} /> : 'Show Both'}
              </Button>
            )}
          </Grid>
          {check ? (
            <Grid item xs={5}>
              <Box
                sx={{
                  height: 500,
                  bgcolor: '#ffffff',
                  overflowY: 'auto'
                }}>
                {/* <Diff string1={noval.replace(/&nbsp;/g, ' ')} string2={html} mode="words" /> */}

                <iframe src={docUrl} width="100%" height="100%"></iframe>
              </Box>
            </Grid>
          ) : (
            ' '
          )}
        </Grid>
      ) : (
        <>
          <HeaderComp />
          <Box
            sx={{
              mx: '0 auto'
            }}>
            <div className={classes.buttonOutline}>
              { /* CKey-112 */
              navenable && lastID === Number(instanceID) ? (
                <Button
                  onClick={() => fetchExercises(location.state?.courseID)}
                  className={classes.button}
                  variant="outlined">
                  Next Session
                </Button>
              ) : (
                <></>
              )}
            </div>
            <Grid align="center">
              <div style={{ position: 'relative' }}>
                {isRestricted && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(255,255,255,0.7)',
                      zIndex: 10,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                      padding: 20,
                      fontSize: 13
                    }}>
                    {accessMessage}
                  </div>
                )}
                
                {instance?.Activities?.Activity?.attributes?.Type != 'VideoTraining' ? (
                  //Temp fix to display Video Activity 34.1 
                  <div
                    style={{
                      pointerEvents: isRestricted ? 'none' : 'auto',
                      opacity: isRestricted ? 0.5 : 1
                    }}>
                    <Button
                      className={classes.button}
                      variant="outlined"
                      onClick={() => viewEditor()}>
                      Launch Activity
                    </Button>
                  </div>
                ) : (
                  <div
                    style={{
                      pointerEvents: isRestricted ? 'none' : 'auto',
                      opacity: isRestricted ? 0.5 : 1
                    }}>
                      <Link to={nextPath} state={links}>
                        <Button
                          className={classes.button}
                          variant="outlined">
                          Next Activity
                        </Button>
                    </Link>
                  </div>
                )}
              </div>
            </Grid>{' '}
          </Box>
        </>
      )}
    </TypingContainer>
  );
};

export default EditorPage;
